export default __webpack_public_path__ + "static/media/120.bb3e8208.svg";